import React from "react";
import {observer} from "mobx-react";
import {SimpleTextDialogProps} from "../../services/dialog/dialog.service.interface";
import {StandardDialogPageComponent} from "./page/standard-dialog-page.component";
import {StandardDialogHeaderComponent} from "./header/standard-dialog-header.component";
import {StandardDialogFooterComponent} from "./footer/standard-dialog-footer.component";
import {PrimaryButton} from "../../basic-components/buttons/primary-button";
import {StandardDialogContentComponent} from "./content/standard-dialog-content.component";
import styled from "styled-components";

const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`

const DialogTextBox = styled.div`
    max-width: 460px;    
    color: ${props => props.theme.colors.dark};
    font-size: ${props => props.theme.fontSize.h3};
    text-align: center;
`



export const SimpleTextDialogComponent: React.FC<SimpleTextDialogProps> = observer((props) => {

    return (
        <StandardDialogPageComponent dialogHandler={props.dialogHandler}>
            <StandardDialogHeaderComponent title={props.title} dialogHandler={props.dialogHandler}/>
            <StandardDialogContentComponent dialogHandler={props.dialogHandler}>
                <ContainerBox>
                    <DialogTextBox>
                        {props.message}
                    </DialogTextBox>
                </ContainerBox>
            </StandardDialogContentComponent>
            <StandardDialogFooterComponent dialogHandler={props.dialogHandler}>
                <PrimaryButton onClick={() => props.dialogHandler.accept()}>
                    {props.buttonText}
                </PrimaryButton>
            </StandardDialogFooterComponent>
        </StandardDialogPageComponent>
    );
});